<template>
    <div>
        <div :class="[ expandable ? 'panel--expand' : 'panel' ]">
            <div class="panel__header">
                <h2>
                    <i class="panel__header__icon icons icon-graduation"></i>
                    <span>{{$t('dashboard.courses.title')}}</span>
                </h2>
            </div>

            <div class="panel__body" :class="{expanded}">
                <div v-if="!coursesItems.length" class="panel--empty">
                    <center>{{$t('dashboard.courses.no_courses')}}</center>
                </div>
                <div v-else class="panel__list">
                    <div v-for="(item, index) in coursesItems" :key="`study_${item.id}_${index}`" class="panel__list__item">
                        <span>{{item.achieved | formatDate}} - {{item.expiration_date ? ($options.filters.formatDate(item.expiration_date)) : $t('dashboard.courses.ongoing')}}</span>
                        <h3 class="purple">{{item.name}}</h3>
                    </div>
                </div>
            </div>

            <div v-if="expandable" class="panel__btn-expand" @click="togglePanelExpansion">
                <div v-if="expanded"><i class="icons icon-arrow-up"></i>{{$t('dashboard.courses.see_less')}}</div>
                <div v-else><i class="icons icon-arrow-down"></i>{{$t('dashboard.courses.see_all')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component({})
    export default class coursesPanel extends Vue {
        name = 'courses-panel';
        expanded = false;

        get coursesItems() {
            return this.$store.state.profile.profile.courses || [];
        }

        togglePanelExpansion() {
            this.expanded = !this.expanded;
        }

        get expandable() {
            return this.coursesItems.length && this.coursesItems.length > 2;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/panels/profile/CoursesPanel.vue